/** @format */

import React, { useState } from 'react'

import { Form, Button, Card, Typography } from 'antd'
import { LockOutlined } from '@ant-design/icons'

import InputField from '../../../../components/Input'

import serviceChangePassword from './service'

import './style.css'

export default function ChangePass(props) {
	const [loadingButton, setLoadingButton] = useState(false)
	const [form] = Form.useForm()

	return (
		<Card>
			<Typography.Text className='ph-change-pass-title'>Cambiar Contraseña</Typography.Text>
			<Form
				name='normal_login'
				className='login-form'
				initialValues={{ remember: true }}
				onFinish={async (item) => {
					setLoadingButton(true)
					await serviceChangePassword(item, props.token)
					setLoadingButton(false)
					form.resetFields()
				}}>
				<InputField
					inputName={'old_password'}
					inputNameLabel={'Contraseña actual'}
					inputNameRule={true}
					inputNameMessage={'Ingresa tu contraseña actual'}
					inputNameType={'password'}
					inputNameIcon={<LockOutlined />}
					inputNameRules={'rulesPassword'}
				/>
				<InputField
					inputName={'new_password'}
					inputNameLabel={'Nueva Contraseña'}
					inputNameRule={true}
					inputNameMessage={'Ingresa una nueva contraseña'}
					inputNameType={'password'}
					inputNameIcon={<LockOutlined />}
					inputNameRules={'rulesPassword'}
				/>
				<Form.Item className='ph-change-pass-button-container'>
					<Button htmlType='submit' className='ph-change-pass-button' loading={loadingButton}>
						Cambiar clave
					</Button>
				</Form.Item>
			</Form>
		</Card>
	)
}
